import axiosInstance from "../../../services/AxiosInstance";
import { buildUrl } from "../../../common/urlBuilder";

export const fetchImagePreviews = async (imgArr) => {
  try {
    if (!Array.isArray(imgArr)) {
      imgArr = [imgArr];
    }
    const getUrl = buildUrl("v1/get-bulk-file");
    const res = await axiosInstance.post(getUrl, {
      fileName: imgArr,
    });
    return res?.data?.data || [];
  } catch (error) {
    console.error("Error fetching image URLs:", error);
  }
};

export const uploadFile = async (formData) => {
  try {
    const url = buildUrl("v1/upload");
    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data?.data || [];
  } catch (error) {
    console.error("Error fetching image URLs:", error);
  }
};

export const fetchFile = async (fileName, key = '') => {
  try {
    const getUrl = buildUrl("v1/get-file");
    const res = await axiosInstance.post(getUrl, {
      fileName: fileName,
      key: key,
    });
    return res?.data?.data?.fileUrl || null;
  } catch (error) {
    console.error("Error fetching file:", error);
  }
};